// src/api/rawItemCategoryService.js ver 01 - Nov 16 2025 5:15 pm - SB107
import { callCloudFunction } from './apiClient';

export const getRawItemCategories = async (tenantid, token, page = 1, limit = 20, statusFilter = 'no-filter') => { //NEW ver 02
  return callCloudFunction('rawItemCategoryCrud', 'GET', null, null, token, null,{
      pathParams: { tenantid, operation: 'list' },
      queryParams: { page, limit, statusfilter: statusFilter }
  });
};

export const getRawItemCategoryById = async (tenantid, id, token) => {
  return callCloudFunction('rawItemCategoryCrud', 'GET', null, id, token, null, {
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addRawItemCategory = async (tenantid, categoryData, token) => {
  return callCloudFunction('rawItemCategoryCrud', 'POST', categoryData, null, token, null, {
      pathParams: { tenantid, operation: 'add' }
  });
};

export const updateRawItemCategory = async (tenantid, id, categoryData, token) => {
  return callCloudFunction('rawItemCategoryCrud', 'PUT', categoryData, null, token, null, {
      pathParams: { tenantid, operation: 'update', id }
  });
};